module.exports = __webpack_public_path__ + "img/icon-return-red.df546a97.svg";